import { render, staticRenderFns } from "./McButton.vue?vue&type=template&id=6c3407f6&scoped=true"
import script from "./McButton.vue?vue&type=script&lang=js"
export * from "./McButton.vue?vue&type=script&lang=js"
import style0 from "./McButton.vue?vue&type=style&index=0&id=6c3407f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3407f6",
  null
  
)

export default component.exports